import React, { useState, useRef, useEffect } from 'react';
import { styleDefinitions as styles } from '../theme/styles';
import { Menu, Settings, ChevronRight, Download, Upload } from 'lucide-react';

interface SettingsMenuProps {
  onManageCategories: () => void;
  onExport: () => void;
  onImport: () => void;
}

export const SettingsMenu: React.FC<SettingsMenuProps> = ({
  onManageCategories,
  onExport,
  onImport
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen]);

  return (
    <div style={{...styles.position.relative}} ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          ...styles.utility.glass,
          ...styles.utility.roundedLg,
          position: 'relative',
          zIndex: 10001,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px'
        }}
        title="Menu"
      >
        <Menu size={20} style={{
          color: "var(--color-gray-700)",
  }} />
      </button>

      {isOpen && (
        <>
          <div style={{...styles.position.inset0, ...styles.position.fixed, zIndex: 10000 }} onClick={() => setIsOpen(false)} />
          <div style={{
    ...styles.components.settingsMenu.dropdown,
    ...styles.animation.fadeIn
  }}>
          <button
            onClick={() => {
              onManageCategories();
              setIsOpen(false);
            }}
            style={{
              ...styles.size.wFull,
              ...styles.spacing.px4,
              ...styles.spacing.py3,
              ...styles.layout.flex,
              alignItems: "center",
              justifyContent: "space-between",
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <div style={{
    ...styles.layout.flex,
     alignItems: "center" ,
    ...styles.spacing.gap3
  }}>
              <Settings size={18} style={{
                color: "var(--color-gray-600)" 
              }} />
              <span style={{
                ...styles.typography.textSm,
                ...styles.typography.fontMedium,
                color: "var(--color-gray-700)" 
              }}>
                Manage Categories
              </span>
            </div>
            <ChevronRight size={16} style={{...styles.typography.textTertiary}}  />
          </button>

          <div style={{...styles.utility.border, ...styles.utility.borderTop}}></div>

          <button
            onClick={() => {
              onExport();
              setIsOpen(false);
            }}
            style={{
              ...styles.size.wFull,
              ...styles.spacing.px4,
              ...styles.spacing.py3,
              ...styles.layout.flex,
              alignItems: "center",
              justifyContent: "space-between",
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <div style={{
    ...styles.layout.flex,
     alignItems: "center" ,
    ...styles.spacing.gap3
  }}>
              <Download size={18} style={{
     color: "var(--color-gray-600)" 
  }} />
              <span style={{
                ...styles.typography.textSm,
                ...styles.typography.fontMedium,
                color: "var(--color-gray-700)" 
              }}>
                Export Data
              </span>
            </div>
            <ChevronRight size={16} style={{...styles.typography.textTertiary}}  />
          </button>

          <button
            onClick={() => {
              onImport();
              setIsOpen(false);
            }}
            style={{
              ...styles.size.wFull,
              ...styles.spacing.px4,
              ...styles.spacing.py3,
              ...styles.layout.flex,
              alignItems: "center",
              justifyContent: "space-between",
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <div style={{
    ...styles.layout.flex,
     alignItems: "center" ,
    ...styles.spacing.gap3
  }}>
              <Upload size={18} style={{
     color: "var(--color-gray-600)" 
  }} />
              <span style={{
                ...styles.typography.textSm,
                ...styles.typography.fontMedium,
                color: "var(--color-gray-700)" 
              }}>
                Import Data
              </span>
            </div>
            <ChevronRight size={16} style={{...styles.typography.textTertiary}}  />
          </button>
        </div>
        </>
      )}
    </div>
  );
};